import React, { useState } from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Route, Switch, useLocation } from 'react-router';
import { Container, Alert } from 'reactstrap';
import AdminAsideMenu from './components/AsideMenu/AdminAsideMenu';
import Layout from './components/Layout';
import AdminHome from './components/Home/AdminHome';
import Accounts from './components/Account/Accounts';
import Account from './components/Account/Account';
import AccountEdit from './components/Account/AccountEdit';
import AccountAdd from './components/Account/AccountAdd';
import Fees from './components/Fee/Fees';
import Fee from './components/Fee/Fee';
import FeeEdit from './components/Fee/FeeEdit';
import Payment from './components/Payment/Payment';
import Payments from './components/Payment/Payments';
import Import from './components/Import/Import';
import Letters from './components/Letters/Letters';
import Reports from './components/Reports/Reports';
import Administration from './components/Administration/Administration';
import FetchData from './components/FetchData';
import FeeAdd from './components/Fee/FeeAdd';
import PaymentEdit from './components/Payment/PaymentEdit';
import MakePayment from './components/MakePayment/MakePayment';

function Admin(props) {
    const [environmentWarningVisible, setEnvironmentWarningVisible] = useState(window.env.environment !== 'production');
    const location = useLocation();
    if (window.env.user.userRoles === null || window.env.user.userRoles.length === 0) {
        location.pathname = '/';
        props.history.replace(location);
        return null;
    }

    return (
        <div id="admin">
            <Alert className="environment-warning" color="warning" isOpen={environmentWarningVisible} toggle={() => setEnvironmentWarningVisible(false)}>
                <div><strong>Warning:</strong> this is the {window.env.environment} version of the site. Production site: <a href="https://danrfees.appssd.sd.gov/admin">https://danrfees.appssd.sd.gov/admin</a></div>
            </Alert>
            <AdminAsideMenu />
            <main>
                <Container>
                    <TransitionGroup className="transition-group">
                        <CSSTransition key={location.key} classNames="fade" timeout={250}>
                            <section className="route-section">
                                <Switch location={location}>
                                    <Route exact path={['/admin', '/admin/home']} component={AdminHome} />
                                    <Route path='/admin/accounts/add' component={AccountAdd} />
                                    <Route path='/admin/accounts/:accountId/edit' component={AccountEdit} />
                                    <Route path='/admin/accounts/:accountId/addfee' component={FeeAdd} />
                                    <Route path='/admin/accounts/:accountId' component={Account} />
                                    <Route path='/admin/accounts' component={Accounts} />
                                    <Route path='/admin/fees/:feeId/edit' component={FeeEdit} />
                                    <Route path='/admin/payments/:paymentId/edit' component={PaymentEdit} />
                                    <Route path='/admin/fees/:feeId' component={Fee} />
                                    <Route path='/admin/fees' component={Fees} />
                                    <Route path='/admin/payments/:paymentId' component={Payment} />
                                    <Route path='/admin/payments' component={Payments} />
                                    <Route path='/admin/makepayment' component={MakePayment} />
                                    <Route path='/admin/import' component={Import} />
                                    <Route path='/admin/letters' component={Letters} />
                                    <Route path='/admin/reports' component={Reports} />
                                    <Route path='/admin/administration' component={Administration} />
                                </Switch>
                            </section>
                        </CSSTransition>
                    </TransitionGroup>
                </Container>
            </main>
        </div>
    );
}

export default Admin;